import { render, staticRenderFns } from "./webhook-events.vue?vue&type=template&id=9c9cc1c4&scoped=true"
import script from "./webhook-events.vue?vue&type=script&lang=js"
export * from "./webhook-events.vue?vue&type=script&lang=js"
import style0 from "./webhook-events.vue?vue&type=style&index=0&id=9c9cc1c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9cc1c4",
  null
  
)

export default component.exports